import Store from "store";
import axios from "axios";
import Qs from "qs";

export function POST(url, data) {
  return new Promise((resolve, reject) => {
    let config = {
      method: "post",
      url: url,
      baseURL: "https://www.weibook.cn/api/",
      data: data || {},
      transformRequest: [
        function(data) {
          if (Store.get("token")) data.token = Store.get("token");
          return Qs.stringify(data);
        }
      ]
    };
    let response = function(response) {
      if (response.data.state == 301) {
        Store.clearAll();
        window.location.replace("/#/login");
        return;
      }
      resolve(response.data);
    };
    axios(config)
      .then(response)
      .catch(function(error) {
        if (error.response.status !== 200) {
          alert("服务器连接失败");
        }
      });
  });
}
export function Logout() {
  Store.clearAll();
  window.location.replace("/#/login");
}
